export default "__VITE_ASSET__m29g5kaV__"